import React, { Component } from 'react'
import uuidv4 from 'uuid/v4'
import SwipeAbleViews from 'react-swipeable-views'
import { autoPlay, virtualize } from 'react-swipeable-views-utils'
import { mod } from 'react-swipeable-views-core'
import * as R from 'ramda'
import { universalOpenUrl, sendTrack, trackSugar } from '~/utils'
import styles from './index.css'

const AutoPlaySwipeableViews = autoPlay(virtualize(SwipeAbleViews))

export default class Index extends Component {
  constructor(props) {
    super(props)
    // 记录打点是否打过，例子 {1: true }，true 标识打过 view
    this.viewTracks = {}
  }
  state = {
    currentIndex: 0,
  }

  componentDidMount() {
    this.trackView(0)
  }

  getIndex = index => {
    const { brandsList } = this.props
    return brandsList.length === 1 ? 0 : mod(index, brandsList.length)
  }

  bannerItemClick = (item, index) => {
    const { md } = this.props
    const { id, imageUrl, targetUrl } = item
    const clickUrlBatch = R.pathOr([], ['clickUrlBatch'], item)
    if (clickUrlBatch.length) {
      clickUrlBatch.forEach(sendTrack)
    }
    trackSugar({
      md,
      cti: id,
      pi: index,
      cu: imageUrl,
      at: 'click',
      et: 'card_click',
      ct: 'custom',
      eu: targetUrl,
    })
    universalOpenUrl(targetUrl)
  }

  handleChangeIndex = index => {
    this.trackView(index)
    this.setState({
      currentIndex: index,
    })
  }

  pagination = (dots, currentIndex) => {
    const { brandsList } = this.props
    const modIndex = mod(currentIndex, brandsList.length)
    const dotsArr = new Array(dots).fill(1)
    return (
      <div className={styles.swiperPagination}>
        <div className={styles.dotWrap}>
          {dotsArr.map((item, index) => {
            return (
              <span
                key={`${uuidv4()}_${modIndex}`}
                className={
                  modIndex === index ? styles.dotActiveStyle : styles.dotStyle
                }
              />
            )
          })}
        </div>
      </div>
    )
  }

  trackView = index => {
    const { brandsList, md } = this.props
    const currentIndex = this.getIndex(index)
    if (!this.viewTracks[currentIndex]) {
      const item = brandsList[currentIndex]
      this.viewTracks[currentIndex] = true
      const exposureUrlBatch = R.pathOr([], ['exposureUrlBatch'], item)
      exposureUrlBatch.forEach(sendTrack)
      const { id, imageUrl, targetUrl } = item
      trackSugar({
        md,
        cti: id,
        pi: currentIndex,
        cu: imageUrl,
        at: 'view',
        et: 'card_show',
        ct: 'custom',
        eu: targetUrl,
      })
    }
  }

  slideRender = ({ key, index }) => {
    const { height, width } = this.props.swiperWH
    const { brandsList, style } = this.props
    const currentIndex = this.getIndex(index)
    const item = brandsList[currentIndex]
    return (
      <div
        onClick={() => this.bannerItemClick(item, currentIndex)}
        key={key}
        style={{
          width: '100%',
          height: `${height}`,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <div style={{ width: `${width}`, height: `${height}` }}>
          <img
            alt=""
            src={item.imageUrl}
            style={{ ...{ width: '100%', height: '100%' }, ...style }}
          />
          {item.wealName && (
            <div className={styles.bannerTitleWrap}>
              <span className={styles.bannerTitle}>{item.wealName}</span>
            </div>
          )}
        </div>
      </div>
    )
  }

  render() {
    const { height } = this.props.swiperWH
    const { currentIndex } = this.state
    const { brandsList } = this.props
    return (
      <div style={({ height: `${height}` }, { position: 'relative' })}>
        {brandsList.length === 1 ? (
          this.slideRender(1, 0)
        ) : (
          <AutoPlaySwipeableViews
            interval={3000}
            onChangeIndex={this.handleChangeIndex}
            slideRenderer={this.slideRender}
          />
        )}
        {brandsList.length > 1 &&
          this.pagination(brandsList.length, currentIndex)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Swipe/index.js